import { MONTHS } from '../constants';

export type SelectProps = {
  label: string;
  value: string;
};

export const makeYearsArray = (maxYear?: number): SelectProps[] => {
  const array: SelectProps[] = [];
  const thisYear: number = new Date().getFullYear();

  for (let i = thisYear - 5; i <= (maxYear || thisYear + 4); i++) {
    array.push({ label: String(i), value: String(i) });
  }

  return array;
};

export const getYearsForBaymaxSelect = (): SelectProps[] => {
  const thisYear: number = new Date().getFullYear();
  const yearArray = [thisYear, thisYear - 1];

  return yearArray.map((year) => ({ label: String(year), value: String(year) }));
};

export const makeMonthsArray = (): SelectProps[] => MONTHS.map((el) => ({ label: el, value: el }));
